import { createNanoEvents } from "@-/com.npmjs.nanoevents";

const statsScrollEmitter = createNanoEvents<{ scrollToTop: () => void }>();

export function subscribeStatsScrollToTop(subscriber: () => void) {
  return statsScrollEmitter.on("scrollToTop", subscriber);
}

/** Consume a focused Stats press only while its Overall list is mounted. */
export function requestStatsScrollToTop(): boolean {
  if ((statsScrollEmitter.events.scrollToTop?.length ?? 0) === 0) {
    return false;
  }
  statsScrollEmitter.emit("scrollToTop");
  return true;
}
